export const Photo = ({ name, alt, sizes = "100vw", eager = false, position = "50% 50%", className = "", testId }) => (
  <img
    src={`/images/${name}-1600.webp`}
    srcSet={`/images/${name}-800.webp 800w, /images/${name}-1600.webp 1600w, /images/${name}-2400.webp 2400w`}
    sizes={sizes}
    alt={alt}
    width={2400}
    height={1800}
    loading={eager ? "eager" : "lazy"}
    decoding={eager ? "sync" : "async"}
    fetchPriority={eager ? "high" : undefined}
    style={{ objectPosition: position }}
    className={`h-full w-full object-cover ${className}`}
    data-testid={testId}
  />
);
